module.exports = __webpack_public_path__ + "img/logo.e2a5fc5b.png";